import AbstractListView from '@UI/Store/AbstractListView';
import type DocumentTemplateVersionView from '@UI/Store/DocumentTemplates/Views/Document/DocumentTemplateVersionView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `organizationId` names the organization this catalogue belongs to. `findById` (numeric version id)
 * is inherited from `AbstractListView`; `forTemplate` filters and orders by `versionNumber`,
 * descending, for a single template's history.
 */
class DocumentTemplateVersionsListView extends AbstractListView<DocumentTemplateVersionView> {
	readonly organizationId: number;

	constructor(list: readonly DocumentTemplateVersionView[], organizationId: number) {
		super(list, 'DocumentTemplateVersionsListView');

		this.organizationId = organizationId;

		Object.freeze(this);
	}

	forTemplate(templateId: number): readonly DocumentTemplateVersionView[] {
		return this.list
			.filter((version) => version.templateId === templateId)
			.slice()
			.sort((first, second) => second.versionNumber - first.versionNumber);
	}
}

export default DocumentTemplateVersionsListView;
